import { render } from "./FraudNoticeAgency.vue?vue&type=template&id=fcfcea3a&scoped=true"
import script from "./FraudNoticeAgency.vue?vue&type=script&lang=js"
export * from "./FraudNoticeAgency.vue?vue&type=script&lang=js"

import "./FraudNoticeAgency.vue?vue&type=style&index=0&id=fcfcea3a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcfcea3a"]])

export default __exports__